export const entityName = 'dataStoreConnectionFields';
export const idAttribute = 'fieldId';
